import { useParams } from "react-router-dom";
import { ContactsContainer } from "../Contacts/useContacts";
import { ContactsPage } from "../Contacts/Contacts";

export function Archive() {
  const { type, id } = useParams();

  return (
    <ContactsContainer.Provider initialState={{ archived: true }}>
      <ContactsPage
        path={"/archive"}
        type={type}
        id={id != null ? Number(id) : null}
      />
    </ContactsContainer.Provider>
  );
}
